import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseViewComponent, FormBase, Required } from '@sb/library/base';
import { CalendarBookingDisplayItem, TimeZoneInfoDisplayItem, WebsiteRenderContextDisplayItem, WebsiteRenderContextTeacherNameDisplayItem } from '@sb/library/data-models';
import { SignUpSlotPickerComponent } from '@sb/library/slot-picker';
import { StepperComponent } from '@sb/library/stepper';
import { BookingMode, CalendarBookingFrontendInputItem, PreFetchedSlots, SignupSteps, SignupStudentMode } from '../signup-form.definitions';

class BookingForm extends FormBase {
    Slot = Required(CalendarBookingDisplayItem);
}

@Component({
    selector: 'lib-signup-form-design-block-booking',
    templateUrl: './signup-form-design-block-booking.component.html',
    styleUrl: './signup-form-design-block-booking.component.scss'
})
export class SignupFormDesignBlockBookingComponent extends BaseViewComponent {

    @ViewChild(SignUpSlotPickerComponent, {static: false}) slotPicker!: SignUpSlotPickerComponent;

    readonly form = BookingForm.Create(false);

    @Input() isViewOnly: boolean = false;
    @Input() renderContext!: WebsiteRenderContextDisplayItem;
    @Input() websiteBlockID!: string;
    @Input() schoolID!: string;
    @Input() signupStudentMode!: SignupStudentMode;
    @Input() stepper!: StepperComponent<typeof SignupSteps>;

    @Input() teachers!: WebsiteRenderContextTeacherNameDisplayItem[];
    @Input() existingEvents: boolean | null = false;
    @Input() eventCategoryIDs: string[] | null = null;
    @Input() preFetchedSlots?: PreFetchedSlots;

    private _mode: BookingMode = BookingMode.Default;
    @Input()
    set mode(value: BookingMode) {
        this._mode = value;
    }

    @Input()
    set currentTimeZone(value: TimeZoneInfoDisplayItem | undefined) {
        this._currentTimezone = value;
    }

    @Output() bookClicked: EventEmitter<CalendarBookingFrontendInputItem> = new EventEmitter();
    @Output() cancelClicked: EventEmitter<void> = new EventEmitter();
    @Output() previousClicked: EventEmitter<void> = new EventEmitter();

    private _bookingClicked: boolean = false;
    private _currentTimezone?: TimeZoneInfoDisplayItem;
    private _previousModeForNoSlots!: BookingMode;

    BookAndSignup() {
        const result = new CalendarBookingFrontendInputItem({
            ...this.form.controls.Slot.value!,
            Mode: this._mode,
            TimezoneID: this.slotPicker.currentTimezone?.ID!
        });
        result.EventPrice = result.PricePerParticipant;
        result.Teacher = this.form.controls.Slot.value?.OriginalTeacher!,
        result.TeacherID = this.form.controls.Slot.value?.OriginalTeacherID!,
        this._bookingClicked = true;
        this._currentTimezone = this.slotPicker.currentTimezone;
        this.bookClicked.emit(result);
    }

    EnableStep(): void {
        this._bookingClicked = false;
    }

    Reset(): void {
        this._bookingClicked = false;
        this.slotPicker.UpdateBookingVisibility();

    }

    FindNewSlot(): void {
        this._mode = BookingMode.ChooseNewSlot;
    }

    ResetSlotPicker(): void {
        this.slotPicker.SlotSelectionChange(null);
    }

    CancelClicked(): void {
        this.slotPicker.UpdateBookingVisibility();
        this.cancelClicked.emit();
    }

    PreviousClicked(): void {
        this.slotPicker.UpdateBookingVisibility();
        this.previousClicked.emit();
    }

    NoSlotsAvailable(noSlotsAvailable: boolean): void {
        if (noSlotsAvailable) {
            this._previousModeForNoSlots = this.mode;
            this._mode = BookingMode.NoSlots;
        } else {
            if (this._mode === BookingMode.NoSlots) {
                this._mode = this._previousModeForNoSlots;
            }
        }
    }

    get mode(): BookingMode {
        return this._mode;
    }

    get BookingMode(): typeof BookingMode {
        return BookingMode;
    }

    get SignupStudentMode(): typeof SignupStudentMode {
        return SignupStudentMode;
    }

    get bookingClicked(): boolean {
        return this._bookingClicked;
    }

    get currentTimezone(): TimeZoneInfoDisplayItem | undefined {
        return this._currentTimezone;
    }

    get currentStepIndex(): number {
        return this.stepper.currentStepPosition + 1;
    }

    get totalStepCounts(): number {
        return this.stepper.totalSteps - 1;
    }
}
